import React, { createContext, useContext, useState, useEffect, useCallback } from "react"
import { useGlobalState } from "./GlobalStateContext"
import { ProgressBar } from 'react-bootstrap'
import { Cookies } from 'react-cookie'
import axios from 'axios'
import Bowser from "bowser";
import lifecycle from 'page-lifecycle'

const assessmentContext = createContext();

export function AssessmentContext({ children }) {
  const { t, API_PATH, alphaRecruitUrlParams, activeComponent, activePage, setActivePage, currentProgress, setCurrentProgress, fillTime, userData, setUserData } = useGlobalState()
  const [activeAssessment, setActiveAssessment] = useState(currentProgress != null ? currentProgress : 0)
  const [userSelectedBtns, setUserSelectedBtns] = useState([])
  const [btnsDisabled, setBtnsDisabled] = useState(false)
  const [cookieDataSet, setCookieDataSet] = useState(false)

  useEffect(() => {
    const cookies = new Cookies()
    if (cookieDataSet === false) {
      cookies.get('selectedBtns') && cookies.get('selectedBtns').length === currentProgress ? setUserSelectedBtns(cookies.get('selectedBtns')) : setUserSelectedBtns([])
      cookies.get('userData') && setUserData(cookies.get('userData'));
      setCookieDataSet(true)
    }
  }, [currentProgress, cookieDataSet, setUserData, userSelectedBtns])

  useEffect(() => {
    const onVisibilityChange = (e) => {
      e.preventDefault()
      e.returnValue = 'return something'
      const cookies = new Cookies()
      activeComponent != null && cookies.set('activeComponent', activeComponent, { path: '/', expires: new Date(Date.now() + 604800), secure: true, sameSite: 'strict' })
      userSelectedBtns.length > 0 && cookies.set('selectedBtns', userSelectedBtns, { path: '/', expires: new Date(Date.now() + 604800), secure: true, sameSite: 'strict' })
      Object.keys(userData).length > 0 && cookies.set('userData', userData, { path: '/', expires: new Date(Date.now() + 604800), secure: true, sameSite: 'strict' })
    }
    lifecycle.addEventListener("statechange", onVisibilityChange)
    return () => lifecycle.removeEventListener("statechange", onVisibilityChange)
  }, [activeComponent, userSelectedBtns, userData])

  useEffect(() => {
    if (activePage === 'Assessment' && currentProgress === userSelectedBtns.length) {
      if (fillTime % 10000 === 0 && userData) {
        axios.post(API_PATH + 'create-participant.php', { method: 'update', participant_id: userData.participant_id, res_id: alphaRecruitUrlParams.res_id, data: JSON.stringify({ progress: currentProgress, filltime: fillTime, component: activeComponent, page: activePage, userAgent: Bowser.parse(window.navigator.userAgent) }) })
          .catch(e => { console.log(e.message) })
      }
    }
  }, [API_PATH, activeComponent, activePage, alphaRecruitUrlParams, currentProgress, fillTime, userData, userSelectedBtns])

  function checkProgress(changeBtnStyleOnClick, lengthAssessment) {
    if (currentProgress === lengthAssessment && currentProgress === activeAssessment) {
      setActivePage('Complete')
    } else if (currentProgress === userSelectedBtns.length && activeAssessment < currentProgress) {
      let current_assessment = userSelectedBtns.find(obj => { return obj.id === activeAssessment })
      changeBtnStyleOnClick(current_assessment.value)
    } else if (userSelectedBtns.length < currentProgress) {
      setActiveAssessment(currentProgress)
    }
  }

  const handleBtnOnClick = useCallback((currentTarget, changeBtnStyleOnClick) => {
    setBtnsDisabled(true);
    changeBtnStyleOnClick(currentTarget.value);

    const timer = setTimeout(() => {
      if (userSelectedBtns) {
        let newArr = [...userSelectedBtns];
        newArr[activeAssessment] = { id: activeAssessment, value: currentTarget.value };
        setUserSelectedBtns(newArr);
      }

      if (currentProgress === activeAssessment) {
        let newProgress = (activeAssessment + 1);
        setCurrentProgress(newProgress);
      }
      setActiveAssessment(activeAssessment + 1);
      setBtnsDisabled(false);
    }, 250);
    return () => clearTimeout(timer);
  }, [activeAssessment, currentProgress, setCurrentProgress, userSelectedBtns])

  function handleBtnBackOnClick() {
    setActivePage('Assessment');
    setActiveAssessment(activeAssessment - 1);
  }

  function resetStates() {
    setUserSelectedBtns([]);
    setActiveAssessment(0);
    setCurrentProgress(0);
    sessionStorage.setItem("selectedBtns", []);
    sessionStorage.setItem("activeAssessment", 0);
    sessionStorage.setItem("progress", 0);
  }

  const renderAssessmentForm = (renderAssessmentBtn, lengthAssessment, strAssessment) => {
    let time = new Date(fillTime).toISOString().substr(14, 5);
    if (activeAssessment < lengthAssessment) {
      return (<>
        <div className='assessment-container col-sm-10 col-md-9 col-lg-8 col-xl-7' key={'div' + strAssessment + activeAssessment}>
          <h4 className='assessment-heading'>{t(strAssessment + ".heading")}</h4>
          {userSelectedBtns.length < currentProgress && <>
            <h6>{t('Assessments.progress_of_user')}<b>{userData.name ? userData.name : t('App.loading')}</b></h6>
            <h6>{t('Assessments.current_fill_time')}<b>{time}</b></h6>
          </>}
          {renderAssessmentBtn(1)}
          {renderAssessmentBtn(2)}
        </div>
        <div className='footer-assessment d-flex justify-content-between col-sm-10 col-md-9 col-lg-8 col-xl-7'>
          <button className='btn btn-footer-assessment' id='btn-footer-back' style={{ visibility: activeAssessment === 0 ? "hidden" : "visible" }} disabled={userSelectedBtns.length < currentProgress} onClick={() => handleBtnBackOnClick()}>{t("App.btn_back")}</button>
          <span className='page-text'>{t("Assessments.assessment")} {t(strAssessment + '.name')} - <b>{activeAssessment + 1} / {lengthAssessment}</b></span>
          <button className='btn btn-footer-assessment' id='btn-footer-next' style={{ visibility: activeAssessment >= currentProgress ? "hidden" : "visible" }} onClick={() => setActiveAssessment(activeAssessment + 1)}>{t("App.btn_next")}</button>
        </div>
        <ProgressBar animated striped now={currentProgress} max={lengthAssessment} label={`${currentProgress} ${t("App.out_of")} ` + lengthAssessment} />
      </>)
    }
  }

  return (
    <assessmentContext.Provider
      value={{ activeAssessment, userSelectedBtns, btnsDisabled, setBtnsDisabled, checkProgress, handleBtnOnClick, handleBtnBackOnClick, renderAssessmentForm, resetStates }}
    >
      {children}
    </assessmentContext.Provider>
  )
}

export function useAssessment() {
  return useContext(assessmentContext)
}